import { isNaN } from 'formik'
import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiFieldText, EuiForm, EuiFormRow, EuiRadio, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { RootState } from 'app/rootReducer'
import { setAiRecommendedBudget, setTargetMonthlyBudget } from 'features/planner/CreateMasterCampaignPlanSlice'

const SetBudgetStep: FC = () => {
  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0
  })

  const dispatch = useDispatch()
  const { aiRecommendedBudget, targetMonthlyBudget } = useSelector((state: RootState) => state.createMasterCampaignPlan)

  const getNumberOnly = (value: string) => {
    return parseInt(value.replaceAll(',', ''))
  }

  const onAiRecommendedBudgetChange = () => {
    dispatch(setAiRecommendedBudget(true))
  }

  const onCustomBudgetChange = () => {
    dispatch(setAiRecommendedBudget(false))
  }

  const onAnyBudgetChange = (e: React.ChangeEvent<HTMLInputElement>, func: (payload: number) => { payload: number; type: string }) => {
    if (!e.target.value) {
      dispatch(func(0))
      return
    }

    if (isNaN(getNumberOnly(e.target.value))) {
      return
    }

    dispatch(func(getNumberOnly(e.target.value)))
  }

  return (
    <>
      <EuiTitle size={'s'}>
        <h2>Step 2: Specify the Budget Approach</h2>
      </EuiTitle>
      <EuiText>AdCritter AI will consider the budget you provide to shape the strategy and create a series of campaigns that follow a detailed media plan.</EuiText>

      <EuiSpacer />

      <EuiRadio id={'ai-recommended-budget'} onChange={onAiRecommendedBudgetChange} checked={aiRecommendedBudget} label={'Let AdCritter AI recommend a budget.'} />
      <EuiRadio id={'custom-budget'} onChange={onCustomBudgetChange} checked={!aiRecommendedBudget} label={'Set a target monthly budget.'} />

      {!aiRecommendedBudget && (
        <>
          <EuiSpacer />
          <EuiForm>
            <EuiFormRow label={'Target Monthly Budget'}>
              <EuiFieldText prepend={'$'} value={targetMonthlyBudget && targetMonthlyBudget > 0 ? formatter.format(targetMonthlyBudget) : ''} onChange={e => onAnyBudgetChange(e, setTargetMonthlyBudget)} />
            </EuiFormRow>
          </EuiForm>
        </>
      )}
    </>
  )
}

export default SetBudgetStep
